import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';

export const IconPersonPlaceholder = ({ classProps }: PropsWithClassProps) => {
  return (
    <svg
      className={classProps?.root}
      viewBox="0 0 294 294"
      fill="currentColor"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="147" cy="110" rx="62" ry="63" />
      <path d="M40 294c0-60 48-104 107-104s107 44 107 104z" />
    </svg>
  );
};
